module.exports = __webpack_public_path__ + "img/空气桥-规则.a84d2ae6.svg";